// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f552192a","239":"8e841f7d","455":"3b7a2b65"}[chunkId] + ".chunk.js";
};